<template>
  <div class="pa-6">
    <div>
      <v-row no-gutters>
        <v-col cols="8" class="d-flex">
          <slot name="head"></slot>
        </v-col>
        <v-col cols="4" class="text-right">
          <slot name="action"></slot>
        </v-col>
      </v-row>
    </div>
    <div class="pt-4 d-flex h-100 w-100">
      <slot name="content"></slot>
    </div>
    <div class="d-none">
      <slot name="dialogs"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props : {
    noGutters : {
      default : true,
    }
  }
};
</script>